import { render, staticRenderFns } from "./createCompanyCategoryModal.vue?vue&type=template&id=56a8894b&"
import script from "./createCompanyCategoryModal.vue?vue&type=script&lang=js&"
export * from "./createCompanyCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports